import Vue from 'vue'
// CRUD config
import crud from "@/settings/crud";
import sidebar from "@/settings/sidebar";

Object.defineProperty(Vue.prototype, '$setting', { value: { crud, sidebar } });